import { types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
// import { AxiosResponse } from "axios";

export default {
    async modify(groupIdx: number, idx: number, param: types.ReqActionState): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/action/state/modify/${groupIdx}/${idx}`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async list(groupIdx: number, param: types.ReqActionGroupList): Promise<types.ResActionStateForAPi> {
        const res = {} as types.ResActionStateForAPi;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/action/state/list/${groupIdx}`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async excelDownload(groupIdx: number, param: types.ReqActionGroupForExcel) {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/action/state/export/excel/${groupIdx}`, param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async detail(idx: number): Promise<types.ResActionStateDetail> {
        const res = {} as types.ResActionStateDetail;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/action/state/detail/${idx}`, {}, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async change(groupIdx: number, idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/action/state/change/${groupIdx}/${idx}`, {}, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async add(groupIdx: number, param: types.ReqActionState): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/action/state/add/${groupIdx}`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
